// Global video configurations for the application
// This file serves as a centralized location for all video resources

export const VIDEO_SECTIONS = {
  CAMPAIGNS: 'CAMPAIGNS',
  ONBOARDING: 'ONBOARDING',
  SEQUENCES: 'SEQUENCES',
  CHANNEL_CONNECTION: 'CHANNEL_CONNECTION',
  // Add more sections as needed
};

export const VIDEOS = {
  [VIDEO_SECTIONS.CAMPAIGNS]: {
    id: VIDEO_SECTIONS.CAMPAIGNS,
    title: 'Campaigns',
    youtubeId: 'nFtCjlEN8Sg',
    description: 'Learn how to create and manage campaigns',
  },
  [VIDEO_SECTIONS.ONBOARDING]: {
    id: VIDEO_SECTIONS.ONBOARDING,
    title: 'Onboarding',
    youtubeId: 'YOUR_ONBOARDING_VIDEO_ID',
    description: 'Get started with our platform',
  },
  [VIDEO_SECTIONS.SEQUENCES]: {
    id: VIDEO_SECTIONS.SEQUENCES,
    title: 'Sequences',
    youtubeId: '3LFW18R6_FQ',
    description: 'Learn how to create and manage sequences',
  },
  [VIDEO_SECTIONS.CHANNEL_CONNECTION]: {
    id: VIDEO_SECTIONS.CHANNEL_CONNECTION,
    title: 'Connect Channel',
    youtubeId: 'VAY9YxQcmak',
    description: 'Learn how to connect your channel',
  },
  // Add more video configurations as needed
};

/**
 * Get video configuration by section
 * @param {string} section - The video section key (e.g., 'campaigns', 'onboarding')
 * @returns {Object|null} Video configuration object or null if not found
 */
export const getVideoConfig = (section) => {
  if (!section) return null;
  return VIDEOS[section.toUpperCase()] || null;
};

/**
 * Get video URL by section
 * @param {string} section - The video section key
 * @returns {string|null} YouTube video URL or null if not found
 */
export const getVideoUrl = (section) => {
  const video = getVideoConfig(section);
  return video ? `https://www.youtube.com/watch?v=${video.youtubeId}` : null;
};

/**
 * Get all video sections
 * @returns {Array} Array of video section objects
 */
export const getAllVideoSections = () => {
  return Object.values(VIDEOS);
};
